import React from "react";

const FormContainer = ({
  children,
  width = "max-w-md",
  spacing = "space-y-8",
}) => {
  return <div className={`${width} w-full ${spacing}`}>{children}</div>;
};

export default FormContainer;
